// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"9fb3223c","496":"8d8889c6","647":"4d0d8b59"}[chunkId] + ".chunk.js";
};